import { render } from "./LoginPage.vue?vue&type=template&id=5a99c538&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=5a99c538&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-5a99c538"

export default script